import React from "react";
import EventCalendar from "../components/events/event-calendar";
import "../styles/components/calendar-tv.css";

export const CalendarTvPage = () => (
  <div className="tv-calendar-wrapper">
    <EventCalendar isTV={true} />
  </div>
);
